import { getIdTokenResult, onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

const useToken = () => {
  const handleToken = (): Promise<string> => {
    return new Promise<string>((res: (value: string) => any, rej) => {
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          try {
            await getIdTokenResult(user).then((IdTokenResult) => {
              res(IdTokenResult.token);
            });
          } catch (err) {
            rej(err);
          }
        } else {
          rej(new Error("No user is signed in"));
        }
      });
    });
  };

  return { handleToken };
};

export default useToken;
